function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22.03 12.03a9.984 9.984 0 01-4.7 8.48 9.948 9.948 0 01-5.3 1.52c-5.52 0-10-4.48-10-10a9.984 9.984 0 014.7-8.48 9.948 9.948 0 015.3-1.52c5.52 0 10 4.48 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1 7.68l-.01 4.55c0 .31-.19.58-.47.69-.09.04-.19.06-.28.06a.75.75 0 01-.53-.22l-8.19-8.2a1.06 1.06 0 01-.1-.12c.38-.32.78-.62 1.21-.89l6.86 6.87.01-2.74a.749.749 0 111.5 0zm3.44 11.94c-.38.32-.78.62-1.21.89l-6.86-6.87-.01 2.74a.749.749 0 11-1.5 0l.01-4.55c0-.31.19-.58.47-.69.27-.12.6-.06.81.16l8.19 8.2c.04.04.07.08.1.12z"
})));